import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {map, tap} from "rxjs/operators";
import {Subscription} from "rxjs";
import {TransactionsV3RestService} from "../../services/rest/v3/transactions-rest.service";
import {ProductsListDataAdapter} from "../../components/account-products/account-products.component";
import {ProductRef} from "../../model/v3/transactions";


@Component({
    selector: 'app-students-products-page',
    templateUrl: './students-products-page.component.html',
    styleUrls: ['./students-products-page.component.css'],
    standalone: false
})
export class StudentsProductsPageComponent implements OnInit, OnDestroy {
  schoolId: number;
  adapter: ProductsListDataAdapter
  private dataSubscription: Subscription;
  constructor(
    route: ActivatedRoute,
    private transactionsRest: TransactionsV3RestService
    ) {
    this.dataSubscription = route.parent.paramMap.pipe(
      map( params => [Number(params.get("schoolId")), Number(params.get("studentId"))]),
      tap( ([schoolId, _]) => this.storeIds(schoolId)),
    ).subscribe(
      ([schoolId, studentId]) => {
        this.adapter = {
          listProducts: () => transactionsRest.getStudentProducts(schoolId, studentId),
          syncProducts: (products: ProductRef[]) =>
            transactionsRest.syncStudentsProducts(schoolId, studentId, products),
        }
      }
    )
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
      this.dataSubscription?.unsubscribe()
  }

  private storeIds(schoolId: number) {
    this.schoolId = schoolId;
  }

}
